<template>
  <div class="app-container">
    <el-card class="mb5">
      <el-form
        ref="queryForm"
        class="searchContainer"
        :model="queryForm"
        label-position="top"
        size="mini"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <!--报价方案名称-->
            <el-form-item :label="$t('basicData.TheNameOfTheQuoteProposal')" prop="name">
              <el-input v-model="queryForm.params.name" :placeholder="$t('orderDetails.pleaseInput')" clearable />
            </el-form-item>
          </el-col>
          <!--          <el-col :span="6">-->
          <!--            &lt;!&ndash;应收主体&ndash;&gt;-->
          <!--            <el-form-item :label="$t('basicData.businessPrincipal')" prop="providerInfoId">-->
          <!--              <el-select-->
          <!--                v-model="queryForm.params.providerInfoId"-->
          <!--                filterable-->
          <!--                clearable-->
          <!--                remote-->
          <!--                :remote-method="getProviderList"-->
          <!--                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"-->
          <!--                style="width: 100%;"-->
          <!--                @change="providerInfoChange()"-->
          <!--              >-->
          <!--                <el-option-->
          <!--                  v-for="item in providerData"-->
          <!--                  :key="item.id"-->
          <!--                  :label="item.providerBody + '（' + item.providerName + '）(' + item.code + ')'"-->
          <!--                  :value="item.id"-->
          <!--                />-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!--          <el-col :span="6">-->
          <!--            &lt;!&ndash;网点&ndash;&gt;-->
          <!--            <el-form-item :label="$t('basicData.Outlets')" prop="siteId">-->
          <!--              <QuerySiteCmp-->
          <!--                :val="queryForm.params.siteId"-->
          <!--                :provider-id="queryForm.params.providerInfoId"-->
          <!--                @change="val => queryForm.params.siteId = val"-->
          <!--              />-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="6">
            <!--业务类型-->
            <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
              <el-select
                v-model="queryForm.params.businessType" :placeholder="$t('GlobalSetObj.pleaseChoose')" clearable
                style="width: 100%;"
              >
                <!--全部-->
                <el-option :label="$t('collectionCenter.tudo')" :value="null" />
                <el-option
                  v-for="item in BUSINESS_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--使用状态-->
            <el-form-item :label="$t('basicData.UsageStatus')" prop="offerPriceStatus">
              <el-select
                v-model="queryForm.params.offerPriceStatus" clearable :placeholder="$t('basicData.pleaseChoose')"
                style="width: 100%;"
              >
                <!--全部-->
                <el-option :label="$t('basicData.all')" value="" />
                <el-option
                  v-for="item in STATUS"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--报价类型-->
            <el-form-item :label="$t('basicData.QuoteType')" prop="offerType">
              <el-select
                v-model="queryForm.params.offerType"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                clearable
              >
                <!--全部-->
                <el-option :label="$t('basicData.all')" value="" />
                <el-option
                  v-for="item in QUOTE_TYPE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--客户-->
            <el-form-item :label="$t('GlobalSetObj.client')">
              <el-select
                v-model="queryForm.params.customerIds"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in customerOption"
                  :key="item.id"
                  :label="item.customerAlias + '（' + item.username + '）'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="6">-->
          <!--服务类型-->
          <!--            <el-form-item :label="$t('newOrder.TypeService')">-->
          <!--              <el-select-->
          <!--                v-model="queryForm.params.expressType"-->
          <!--                :placeholder="$t('basicData.PleaseSelect')"-->
          <!--                style="width: 100%;"-->
          <!--                filterable-->
          <!--                clearable-->
          <!--              >-->
          <!--                <el-option-->
          <!--                  v-for="item in EXPRESS_TYPE"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.name"-->
          <!--                  :value="item.value"-->
          <!--                />-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col :span="6">
            <!--货物类型-->
            <el-form-item :label="$t('placeOrder.cargoType')">
              <el-select
                v-model="queryForm.params.cargoType"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                filterable
                clearable
              >
                <el-option
                  v-for="item in CARGO_TYPE"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!--账单类型-->
            <el-form-item :label="$t('receivablePayable.billType')">
              <el-select
                v-model="queryForm.params.billType"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                filterable
                clearable
              >
                <el-option
                  v-for="item in BILL_TYPE"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 揽收方式  -->
          <el-col :span="6">
            <el-form-item :label="$t('collectionCenter.lanshouTypee')">
              <CollectTypeCmp
                :value="queryForm.params.collectType"
                :business-type="0"
                @change="val => (queryForm.params.collectType = val)"
              />
            </el-form-item>
          </el-col>
          <!-- 折扣系数  -->
          <el-col :span="6">
            <el-form-item :label="$t('basicData.DiscountFactor')">
              <el-select
                v-model="queryForm.params.discountStatus"
                :placeholder="$t('basicData.PleaseSelect')"
                style="width: 100%;"
                clearable
              >
                <el-option
                  v-for="item in DISCOUNT_COEFFICIENT"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row type="flex" justify="left">
        <el-col :span="8">
          <div style="margin-top: 10px;">
            <!--查询-->
            <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              @click="getDataSearch"
            >{{ $t('basicData.Search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh"
              size="mini"
              @click="queryFormReset"
            >{{ $t('basicData.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <div class="mb10">
        <!--添加-->
        <el-button
          v-permit:remove="'btn:finance:basicData:quotationManagement:add'"
          size="mini"
          type="primary"
          icon="el-icon-plus"
          @click="handlerOperation(1)"
        >{{ $t('basicData.Add') }}
        </el-button>
      </div>

      <el-table
        ref="elTable"
        :data="tableData"
        border
        class="table-height"
        highlight-current-row
        current-row-key="id"
        :height="tableHeightRow.height"
      >
        <!--序号-->
        <el-table-column :label="$t('basicData.serialNumber')" width="60px" align="center">
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--报价方案名称-->
        <el-table-column
          prop="name"
          :label="$t('basicData.TheNameOfTheQuoteProposal')"
          align="left"
          width="160"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-end"
              popper-class="copy"
              trigger="hover"
            >
              <el-button style="color: black;font-size: 12px" type="text" @click="copy(scope.row.name)">
                {{ $t('orderDetails.copy') }}
              </el-button>
              <span slot="reference" class="WaybillNumber" @click="handlerOperation(2, scope.row)">
                {{ scope.row.name }}
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <!--分区方案名称-->
        <el-table-column
          prop="partitionName"
          :label="$t('basicData.PartitionSchemeName')"
          align="left"
          width="160"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div class="WaybillNumber" @click="handlerOperation(3, scope.row)">
              {{ scope.row.partitionName }}
            </div>
          </template>
        </el-table-column>
        <!--服务类型-->
        <!--        <el-table-column-->
        <!--          prop="expressType"-->
        <!--          :label="$t('newOrder.TypeService')"-->
        <!--          align="center"-->
        <!--          width="140"-->
        <!--          :show-overflow-tooltip="true"-->
        <!--        >-->
        <!--          <template slot-scope="scope">-->
        <!--            <span>{{ EXPRESS_TYPE[scope.row.expressType] ? EXPRESS_TYPE[scope.row.expressType].name : '' }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--货物类型-->
        <el-table-column
          prop="cargoType"
          :label="$t('placeOrder.cargoType')"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ CARGO_TYPE[scope.row.cargoType] ? CARGO_TYPE[scope.row.cargoType].name : '' }}</span>
          </template>
        </el-table-column>
        <!--账单类型-->
        <el-table-column
          prop="billType"
          :label="$t('receivablePayable.billType')"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ BILL_TYPE[scope.row.billType] ? BILL_TYPE[scope.row.billType].name : '' }}</span>
          </template>
        </el-table-column>
        <!--应收主体-->
        <!--        <el-table-column-->
        <!--          prop="providerInfoName"-->
        <!--          :label="$t('basicData.businessPrincipal')"-->
        <!--          align="center"-->
        <!--          width="140"-->
        <!--          :show-overflow-tooltip="true"-->
        <!--        />-->
        <!--网点-->
        <!--        <el-table-column-->
        <!--          prop="siteName"-->
        <!--          :label="$t('basicData.Outlets')"-->
        <!--          align="center"-->
        <!--          width="140"-->
        <!--          :show-overflow-tooltip="true"-->
        <!--        />-->
        <!--客户-->
        <el-table-column
          prop="customerName"
          :label="$t('GlobalSetObj.client')"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
        />
        <!--报价类型-->
        <el-table-column
          prop="offerType"
          :label="$t('basicData.QuoteType')"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ QUOTE_TYPE[scope.row.offerType].label || '' }}</span>
          </template>
        </el-table-column>
        <!--业务类型-->
        <el-table-column
          prop="businessType"
          :label="$t('collectionCenter.businessT')"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <!--            <div>-->
            <!--              &lt;!&ndash;快递&ndash;&gt;-->
            <!--              <span v-if="scope.row.businessType === 0">{{ $t('collectionCenter.expressDelivery') }}</span>-->
            <!--              &lt;!&ndash;揽收&ndash;&gt;-->
            <!--              <span v-else-if="scope.row.businessType === 1">{{ $t('collectionCenter.lanshou') }}</span>-->
            <!--              &lt;!&ndash;派件&ndash;&gt;-->
            <!--              <span v-else-if="scope.row.businessType === 2">{{ $t('collectionCenter.delivery') }}</span>-->
            <!--              &lt;!&ndash;快递\揽收&ndash;&gt;-->
            <!--              <span v-else-if="scope.row.businessType === 3">{{ $t('collectionCenter.expressDelivery') }}、{{ $t('collectionCenter.lanshou') }}</span>-->
            <!--              &lt;!&ndash;快递\派件&ndash;&gt;-->
            <!--              <span v-else-if="scope.row.businessType === 4">{{ $t('collectionCenter.expressDelivery') }}、{{ $t('collectionCenter.delivery') }}</span>-->
            <!--              &lt;!&ndash;揽收\派件&ndash;&gt;-->
            <!--              <span v-else-if="scope.row.businessType === 5">{{ $t('collectionCenter.lanshou') }}、{{ $t('collectionCenter.delivery') }}</span>-->
            <!--              &lt;!&ndash;快递\揽收\派件&ndash;&gt;-->
            <!--              <span v-else-if="scope.row.businessType === 6">{{ $t('collectionCenter.expressDelivery') }}、{{ $t('collectionCenter.lanshou') }}、{{ $t('collectionCenter.delivery') }}</span>-->
            <!--            </div>-->
            <span>{{ BUSINESS_TYPE[scope.row.businessType].label || '' }}</span>
          </template>
        </el-table-column>
        <!--揽收方式-->
        <el-table-column
          prop="collectType"
          :label="$t('collectionCenter.lanshouTypee')"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.collectType ? (COLLECT_TYPE[scope.row.collectType].label || '') : '' }}</span>
          </template>
        </el-table-column>
        <!--折扣系数-->
        <el-table-column
          prop="discountStatusStr"
          :label="$t('basicData.DiscountFactor')"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
        />
        <!--折扣率-->
        <el-table-column
          prop="discountRate"
          :label="$t('basicData.DiscountRate')"
          align="center"
          width="140"
        />
        <!--使用类型-->
        <!--        <el-table-column-->
        <!--          prop="offerAttr"-->
        <!--          :label="$t('basicData.UsageType')"-->
        <!--          align="center"-->
        <!--          width="140"-->
        <!--          :show-overflow-tooltip="true"-->
        <!--        >-->
        <!--          <template slot-scope="scope">-->
        <!--            &lt;!&ndash;1:应收 2:应付&ndash;&gt;-->
        <!--            <span v-if="scope.row.offerAttr === 1">{{ $t('basicData.Receivables') }}</span>-->
        <!--            &lt;!&ndash;应付&ndash;&gt;-->
        <!--            <span v-else-if="scope.row.offerAttr === 2">{{ $t('basicData.payable') }}</span>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--使用状态-->
        <el-table-column
          prop="offerPriceStatus"
          :label="$t('basicData.UsageStatus')"
          align="center"
          width="140"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag :type="STATUS[scope.row.offerPriceStatus] && STATUS[scope.row.offerPriceStatus].type">{{ STATUS[scope.row.offerPriceStatus] && STATUS[scope.row.offerPriceStatus].label || '' }}</el-tag>
          </template>
        </el-table-column>
        <!--有效期开始-->
        <el-table-column
          prop="startTime"
          :label="$t('basicData.TheValidityPeriodBegins')"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
        />
        <!--有效期结束-->
        <el-table-column
          prop="endTime"
          :label="$t('basicData.EndOfValidityPeriod')"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
        />
        <!--创建人-->
        <el-table-column
          prop="createUserStr"
          :label="$t('basicData.CreatePeople')"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
        />
        <!--创建时间-->
        <el-table-column
          prop="createTime"
          :label="$t('basicData.CreationTime')"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
        />
        <!--最后修改人-->
        <el-table-column
          prop="updateUserStr"
          :label="$t('basicData.LastModifier')"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
        />
        <!--最后修改时间-->
        <el-table-column
          prop="updateTime"
          :label="$t('basicData.LastModified')"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
        />
        <!--备注-->
        <!--        <el-table-column-->
        <!--          prop="remark"-->
        <!--          :label="$t('basicData.remark')"-->
        <!--          align="left"-->
        <!--          :show-overflow-tooltip="true"-->
        <!--        />-->
        <el-table-column
          :label="$t('basicData.operate')" fixed="right" align="center"
          width="240"
        >
          <template slot-scope="scope">
            <div class="operate">
              <!--确定禁用吗？-->
              <el-popconfirm
                v-if="scope.row.status === true"
                v-permit="'but:finance:basicData:accountManagement:edit'"
                :title="$t('basicData.AreYouSureDisabled')"
                @confirm="asyncPartitionEdit(scope.row, 0)"
              >
                <!--禁用-->
                <el-button
                  slot="reference" class="ml" type="danger"
                  size="mini"
                >{{ $t('basicData.disable') }}</el-button>
              </el-popconfirm>
              <!--确定启用吗？-->
              <el-popconfirm
                v-if="scope.row.status === false"
                v-permit="'btn:finance:basicData:quotationManagement:edit'"
                :title="$t('basicData.AreYouSureEnabled')"
                @confirm="asyncPartitionEdit(scope.row, 1)"
              >
                <!--启用-->
                <el-button
                  slot="reference" class="ml" type="primary"
                  size="mini"
                >{{ $t('basicData.enable') }}</el-button>
              </el-popconfirm>

              <!-- 复制 -->
              <el-popover
                placement="bottom-start"
                trigger="click"
              >
                <div class="feet">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="() => handlerOperation(4, scope.row)"
                  >{{ $t('basicData.CopyAll') }}</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    class="feet-btn"
                    @click="() => handlerOperation(5, scope.row)"
                  >{{ $t('basicData.PartialCopy') }}</el-button>
                </div>
                <el-button
                  slot="reference"
                  v-permit:remove="'btn:finance:basicData:quotationManagement:add'"
                  type="info"
                  size="mini"
                >{{ $t('orderDetails.copy') }}<i class="el-icon-arrow-down el-icon--right" /></el-button>
              </el-popover>

              <!-- 快递/整车业务-折扣系数启用 -->
              <el-button
                v-if="[0, 8].includes(scope.row.businessType) && scope.row.discountStatus"
                class="feet-btn"
                type="danger"
                size="mini"
                @click="addBasicData(scope.row)"
              >
                {{ $t('basicData.Discount') }}
              </el-button>

              <!--删除-->
              <!--              <el-popconfirm-->
              <!--                v-permit="'but:finance:basicData:quotationManagement:delete'"-->
              <!--                :title="$t('basicData.AreYouSureYouWantToDelete')"-->
              <!--                @confirm="deleteAccount(scope.row)"-->
              <!--              >-->
              <!--                &lt;!&ndash;删除&ndash;&gt;-->
              <!--                <el-button slot="reference" class="ml" type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>-->
              <!--              </el-popconfirm>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="getData"
          @size-change="getData"
        />
      </div>
    </el-card>

    <!-- 添加、详情 -->
    <el-drawer
      :visible.sync="drawerObj.visible"
      :with-header="false"
      direction="ltr"
      size="90%"
    >
      <DetailCmp
        :key="editKey"
        :edit-data="drawerObj.editData"
        :operation-type="drawerObj.typeIndex"
        :copy-model="drawerObj.copyModel"
        @saveChange="updatePage"
      />
    </el-drawer>

    <!--分区详情-->
    <el-drawer
      :visible.sync="showPartitionDetail"
      :with-header="false"
      direction="ltr"
      size="80%"
    >
      <PartitionDetails
        :key="editKeyPartition"
        :type-index="3"
        :edit-data="drawerObj.editData"
        :all-state="allState"
        :all-city="allCity"
        style="height: 100%;"
        @updatePage="updatePage"
      />
    </el-drawer>

    <!--    折扣系数弹窗-->
    <DiscountDiaLog
      ref="discountDiaLog"
      :ids="offerPriceId"
    />

    <!--    复制-->
    <el-dialog
      :title="$t('orderDetails.copy')"
      :visible.sync="copyVisible"
      append-to-body
      width="600px"
    >
      <CopyLog
        @submit="submitCopy"
        @close="cancelCopy"
      />
    </el-dialog>
  </div>
</template>

<script>
import { apiOfferPricePage, apiOfferPriceSwitch } from '@/api/finance/basicData';
import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { copyData } from '@/utils/copyData';
import estimateTableHeight from '@/views/finance/mixins/estimateTableHeight.js';
import toolRequestClass from '@/views/finance/mixins/toolRequestClass';
import { EXPRESS_TYPE, CARGO_TYPE, BILL_TYPE, DISCOUNT_COEFFICIENT } from './cmp/utils';
import { BUSINESS_TYPE, COLLECT_TYPE, QUOTE_TYPE } from '@/views/finance/enums';
import { STATUS } from '@/views/finance/utils';
import CollectTypeCmp from '@/views/finance/basicData/quotationManagement/cmp/CollectTypeCmp.vue';
import DiscountDiaLog from '@/views/finance/basicData/quotationManagement/cmp/discountDiaLog.vue';
import CopyLog from '@/views/finance/cmp/Dialog/copyLog.vue';

export default {
  name: 'QuotationManagement',
  components: {
    CopyLog,
    DiscountDiaLog,
    CollectTypeCmp,
    DetailCmp: () => import('./cmp/detailLog'),
    PartitionDetails: () => import('@/views/finance/basicData/partition/cmp/DetailsCmp.vue')
    // QuerySiteCmp: () => import('@/views/finance/cmp/Query/QuerySiteCmp.vue')
  },
  mixins: [estimateTableHeight, toolRequestClass],

  data() {
    return {
      EXPRESS_TYPE,
      CARGO_TYPE,
      BILL_TYPE,
      BUSINESS_TYPE,
      QUOTE_TYPE,
      COLLECT_TYPE,
      DISCOUNT_COEFFICIENT,
      STATUS,
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        orderDirection: 'DESC',
        params: {
          name: '', // 报价名称
          // providerInfoId: '', // 应收主体id
          // siteId: '', // 网点id
          businessType: null,
          offerAttr: 1, // 使用类型 1:应收 2:应付
          offerPriceStatus: '', // 状态
          offerType: '', // 报价类型
          customerIds: [], // 客户
          // expressType: '', // 服务类型
          cargoType: '', // 货物类型
          billType: '', // 账单类型
          collectType: '', // 揽收方式
          discountStatus: '' // 折扣系数
        }
      },
      tableData: [],
      total: 0,
      drawerObj: {
        visible: false,
        typeIndex: 1,
        copyModel: 0, // 默认全部
        editData: {}
      },
      editKey: new Date().getTime(),
      userIdAndNameObj: null,
      outletsList: [], // 站点选项
      showPartitionDetail: false,
      editKeyPartition: new Date().getTime(),
      customerOption: [],
      offerPriceId: [], // 报价id
      copyVisible: false // 复制弹窗
    };
  },

  created() {
    this.userIdAndNameObj = getUserIdAndNameObj();
    this.getDataSearch();
    // 获取客户选项
    this.getCustomerOption('');
    // 获取分页主体选项
    this.getProviderList();
    const allCity = localStorage.getItem('allCity');
    const allState = localStorage.getItem('allState');
    setTimeout(() => {
      // 获取所有一级州
      if (allState) {
        this.allState = JSON.parse(allState);
      } else {
        this.getAllState({ level: 1, parentId: '' });
      }
      if (allCity) {
        this.allCity = JSON.parse(allCity);
      } else {
        // 获取城市
        this.getAllState({ level: 2, parentId: '' });
      }
    }, 500);
  },
  methods: {
    // 折扣系数
    addBasicData(row) {
      this.offerPriceId = [row.id];
      this.$refs.discountDiaLog.open();
    },
    // 应收主体变化
    // providerInfoChange() {
    //   this.queryForm.params.siteId = '';
    // },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 搜索
    getDataSearch() {
      this.queryForm.pageNumber = 1;
      this.getData();
    },
    // 重置
    queryFormReset() {
      this.queryForm.params = {
        name: '', // 报价名称
        providerInfoId: '', // 应收主体id
        siteId: '', // 网点id
        businessType: null,
        offerAttr: 2, // 使用类型 1:应收 2:应付
        offerPriceStatus: '', // 报价状态 已过期:0 使用中:1 未启用:2
        offerType: '', // 1:标准价 2:应收主体价 3:网点价
        customerIds: [], // 客户
        expressType: '', // 服务类型
        cargoType: '', // 货物类型
        billType: '' // 账单类型
      };
    },
    /**
     * 查看详情
     * @param type 1 新增报价 2 编辑报价 3 查看分区详情 4复制 5 部分复制
     * @param row 报价详情数据
     */
    handlerOperation(type, row) {
      const timestamp = new Date().getTime();
      this.drawerObj.editData = row || {};

      if (type === 3) {
        this.showPartitionDetail = true;
        this.editKeyPartition = timestamp;
        return;
      }

      if (type === 5) {
        this.copyVisible = true;
        return;
      }

      this.editKey = timestamp;
      this.drawerObj.copyModel = 0;
      this.drawerObj.typeIndex = type;
      this.drawerObj.visible = true;
    },
    // 部分复制
    submitCopy(form) {
      // model 1 基础规则 2 其他规则
      const { model } = form;
      this.drawerObj.copyModel = model;
      this.drawerObj.typeIndex = 4;
      this.editKey = new Date().getTime();
      this.drawerObj.visible = true;
    },
    // 关闭弹窗
    cancelCopy() {
      this.copyVisible = false;
    },
    // 获取列表数据
    getData() {
      this.queryForm.params.name = this.queryForm.params.name ? this.queryForm.params.name.trim() : '';
      apiOfferPricePage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records.map(item => {
            const updateUserStr = getUserName(item.updateUser, this.userIdAndNameObj);
            const createUserStr = getUserName(item.createUser, this.userIdAndNameObj);
            const discountStatusStr = item.discountStatus ? DISCOUNT_COEFFICIENT[item.discountStatus].name : '';
            return {
              ...item,
              updateUserStr,
              createUserStr,
              discountStatusStr
            };
          });
          console.log(this.tableData);
          this.total = res.data.total;
        }
      });
    },
    // 启用、禁用
    asyncPartitionEdit(row, type) {
      const param = {
        id: row.id,
        sw: type
      };
      apiOfferPriceSwitch(param).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
          this.getDataSearch();
        }
      });
    },

    // 数据更新
    updatePage(type) {
      if (type) {
        this.getData();
      }
      this.drawerObj.visible = false;
      this.showPartitionDetail = false;
    }
  }
};
</script>

<style scoped>
.WaybillNumber {
  color: #00A551;
  cursor: pointer;
}

.operate {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
